export const getStoreDisplayName = store => {
  let name = store.StoreNumber;
  name = `${name}-${store.StoreName || store.StoreNumber}`;

  return name;
};

export const getEmailIdCount = inputEmail => {
  if (inputEmail) {
    const regexMatch = inputEmail.match(/@/g)
    return (regexMatch ? regexMatch.length : 0)
  } else {
    return 0
  }
 
}



// WEBPACK FOOTER //
// ./src/components/LeaderBoard/helpers/formatting.js